export const tr = {
    'active-banners': 'Aktif reklamlar',
    'active-campaigns': 'Aktif kampanyalar',
    'active-cpc-campaigns': 'Tıklama başına ödenen aktif kampanyalar',
    'active-cpm-campaigns': 'Gösterim başına ödenen aktif kampanyalar',
    'active-groups': 'Aktif gruplar',
    'all-active-groups': 'Aktif gruplar',
    'all-archived-groups': 'Arşiv grupları',
    'all-banners': 'Tüm reklamlar',
    'all-campaigns': 'Tüm kampanyalar',
    'all-cpc-campaigns': 'Tıklama başına ödenen kampanyalar',
    'all-cpm-campaigns': 'Gösterim başına ödenen kampanyalar',
    'all-groups': 'Tüm gruplar',
    'all-phrases': 'Tüm sözcük grupları',
    'all-targetings': 'Tüm gösterim koşulları',
    'archive-banners': 'Arşiv reklamları',
    'archive-campaigns': 'Arşiv kampanyaları',
    'archive-cpc-campaigns': 'Tıklama başına ödenen arşiv kampanyaları',
    'archive-cpm-campaigns': 'Gösterim başına ödenen arşiv kampanyaları',
    'archive-groups': 'Arşiv grupları',
    'archived-status': 'Archive',
    banners: 'Reklamlar',
    'cpc-campaigns': 'Tıklama bazında',
    'cpm-campaigns': 'Gösterim bazında',
    'draft-status': 'Draft',
    'minus-phrase-binding-error-grid-alert-message':
        'Bu gruplara negatif anahtar sözcük grubu dizileri bağlanamadı. Maksimum sayıda dizi zaten bağlı olabilir',
    'minus-phrase-unbinding-error-grid-alert-message':
        'Bu gruplara ait negatif anahtar sözcük grubu dizilerinin bağlantısı kesilemedi',
    'pause-status': 'Paused',
    phrases: 'Sözcük grupları',
    'regions-transform-error-grid-alert-message': 'Bu gruplarda gösterim bölgeleri değiştirilemedi',
    'run-ok-status': 'Active',
    'run-warn-status': 'Active with restrictions',
    'stop-status': 'Stopped',
    targetings: 'Hedeflemeler'
};
